import '../i18n';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { PageNavigation } from './PageNavigation';
import { useLocation, useSearchParams } from 'react-router-dom';
import { authRoutes, routesWithoutHeader, routesWithFooter } from '@/utils/routsConst';
import { autodeleteItem } from '@/utils/maxAttemptsSetter';
import Cookies from 'js-cookie';
import { selectUsers } from '@/features/user/userSlice';
import { useAppSelector, useAppDispatch } from './hooks';
import { InitialLanguageModal } from '@/components/InitialLanguageModal';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { WebNotifications } from '@/components/WebNotifications/Notification';
import { fetchPublicSettings } from '@/features/publicSettings/publicSettingsSlice';
import { GeneralConditionsModal } from '@/components/GeneralConditionsModal';
import { selectTermsAndConditions } from '@/features/termsAndConditions/termsAndConditionsSlice';
import { initCurrencyConfig } from '@/utils/currencyConfig';
import { initLanguageConfig, getDefaultLanguage } from '@/utils/languageConfig';
import i18n from 'i18next';

export const App: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { currentUser } = useAppSelector(selectUsers);
  const { showModal: showTermsAndConditionsModal } = useAppSelector(selectTermsAndConditions);
  const [searchParams] = useSearchParams();

  setInterval(autodeleteItem, 600000);

  const renderApp = () => {
    return (
      <div className='app' id='app'>
        <InitialLanguageModal />
        {showTermsAndConditionsModal && <GeneralConditionsModal />}
        {Cookies.get('accessToken') && currentUser.id && currentUser.id && !routesWithoutHeader.includes(location.pathname) && <Header />}
        {<WebNotifications />}
        {<PageNavigation />}
        {/* {!loginRoutes.includes(location.pathname) && <QuestionBlock /> } */}
        {routesWithFooter.includes(location.pathname) && <Footer authRoutes={authRoutes.includes(location.pathname)} />}
      </div>
    );
  };

  useEffect(() => {
    searchParams.get('language') && localStorage.setItem('language', searchParams.get('language') as string);
    dispatch(fetchPublicSettings())
      .unwrap()
      .then(settings => {
        initCurrencyConfig(settings);
        initLanguageConfig(settings);
        if (!localStorage.getItem('language') && !searchParams.get('language')) {
          const defaultLang = getDefaultLanguage();
          i18n.changeLanguage(defaultLang);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {process.env.REACT_APP_SENTRY_DSN === 'disabled' ? (
        renderApp()
      ) : (
        <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>{renderApp()}</Sentry.ErrorBoundary>
      )}
    </>
  );
};
